import { useState, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { FaInstagram, FaMapMarkerAlt, FaCertificate } from "react-icons/fa";
import profileLogo from '../../assets/logo.png'; // Adjust path as needed

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuItemClick = (sectionId) => {
    setActiveSection(sectionId);
    setIsOpen(false);
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const menuItems = [
    { id: "about", label: "About" },
    { id: "products", label: "Menu" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition duration-300 ${isScrolled ? "bg-[#050414] bg-opacity-50 backdrop-blur-md shadow-md" : "bg-transparent"
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-20 py-5 flex items-center justify-between">
        {/* Left: Logo */}
        <div className="text-white text-lg font-semibold cursor-pointer flex-shrink-0">
          {/* Clickable logo */}
          <a href="/" className="flex items-center">
            <img
              src={profileLogo}
              alt="Food Square Logo"
              className="h-20 w-auto mr-6" // Larger logo
            />
          </a>
        </div>

        {/* Center: Menu */}
        <ul className="hidden md:flex items-center space-x-6 text-gray-300 font-medium">
          {menuItems.map((item) => (
            <li
              key={item.id}
              className={`cursor-pointer hover:text-[#8245ec] ${activeSection === item.id ? "text-[#8245ec]" : ""
                }`}
            >
              <button onClick={() => handleMenuItemClick(item.id)}>{item.label}</button>
            </li>
          ))}
        </ul>

        {/* Right: Social Icons */}
        <div className="hidden md:flex items-center space-x-4 ml-4 text-gray-300">
          {/* Certification Icon */}
          <a
            href="https://drive.google.com/file/d/1i-5rUx0yNCr5L69KkLFWompSHtAePygf/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#ffc107]"
            title="See Certification"
          >
            <FaCertificate size={22} />
          </a>
          {/* Instagram */}
          <a
            href="https://www.instagram.com/food_square_sbz/?utm_source=qr&igsh=dmZlanJoY3hzcHBs# "
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#8245ec]"
          >
            <FaInstagram size={22} />
          </a>
          {/* Map Icon */}
          <a
            href="https://maps.app.goo.gl/1ZqLPYX4f9AWt6Rx7"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#8245ec]"
            title="Find us on Map"
          >
            <FaMapMarkerAlt size={22} />
          </a>
        </div>

        {/* Mobile Menu Icon */}
        <div className="md:hidden">
          {isOpen ? (
            <FiX className="text-3xl text-[#8245ec] cursor-pointer" onClick={() => setIsOpen(false)} />
          ) : (
            <FiMenu className="text-3xl text-[#8245ec] cursor-pointer" onClick={() => setIsOpen(true)} />
          )}
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-16 left-1/2 transform -translate-x-1/2 w-4/5 bg-[#050414] bg-opacity-50 backdrop-blur-lg z-50 rounded-lg shadow-lg md:hidden">
          <ul className="flex flex-col items-center space-y-4 py-4 text-gray-300">
            {menuItems.map((item) => (
              <li
                key={item.id}
                className={`cursor-pointer hover:text-white ${activeSection === item.id ? "text-[#8245ec]" : ""
                  }`}
              >
                <button onClick={() => handleMenuItemClick(item.id)}>{item.label}</button>
              </li>
            ))}
            <div className="flex space-x-4 pt-2">
              {/* Certification Icon */}
              <a
                href="https://drive.google.com/file/d/1i-5rUx0yNCr5L69KkLFWompSHtAePygf/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#ffc107]"
                title="See Certification"
              >
                <FaCertificate size={24} />
              </a>
              {/* Instagram */}
              <a
                href="https://www.instagram.com/food_square_sbz/?utm_source=qr&igsh=dmZlanJoY3hzcHBs#"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >
                <FaInstagram size={24} />
              </a>
              {/* Map Link */}
              <a
                href="https://maps.app.goo.gl/1ZqLPYX4f9AWt6Rx7"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
                title="Find us on Map"
              >
                <FaMapMarkerAlt size={24} />
              </a>
            </div>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
